import React from 'react';
import { Link } from 'react-router-dom';


const Footer = () => {

    // useEffect(() => {
    //     window.scrollTo(0, 0)
    //  }, [])


    return (
        <>

            <footer style={{ marginBottom: "-2rem" }} className="mt-5">

                <div className='background5' style={{ background: "rgb(77 135 25)", opacity: "" }} >
                    <div className='transbox5' >
                        <div className='container'>
                            <div className='row'>
                                <div className="col-sm-6 col-md-4  mt-5 mb-5" >
                                    <ul  >

                                        <h3 className="text-white mt-4" >Girnai Shikshan Sanstha</h3>
                                        {/* <img  className="mt-4" src={image} classNAme="mb-5" alt="error" style={{width:"50px" ,height:"50px"}}></img>   */}
                                        <p className="mt-3 text-white" > Girnai shikshan sanstha was established in 1989.A total of four schools.
                                            of girnai shikshan sanstha are located in pachora.it is reputed for the the quality of its faculty and outstanding
                                            platform to the student for undergraduate and postgraduate program.
                                            Now girnai shikshan sanstha is starting shinde institute of pharmacy and research from this year.</p>
                                        <Link to="/aboutus" className="btn btn-outline-warning " style={{ marginTop: "1rem" }}>Know More</Link>

                                    </ul>
                                </div>


                                <div className="col-sm-6 col-md-2 mt-5 mb-5" >

                                    <ul>
                                        <br />
                                        <h3 className="text-white mb-4" >Quick Link</h3>
                                        <li className='zoom marginFooter' style={{ marginTop: "0.7rem" }}><Link to="/contactus" className="text-white color mt-1"> <i className="fa fa-angle-right" aria-hidden="true"></i> Contact Us</Link></li>
                                        <li className='zoom marginFooter' style={{ marginTop: "0.7rem" }}>  <Link to="/about" className="text-white  color "> <i className="fa fa-angle-right" aria-hidden="true"></i> About Us</Link></li>
                                        <li className='zoom marginFooter' style={{ marginTop: "0.7rem" }}><Link to="/admission" className="text-white  color "><i className="fa fa-angle-right" aria-hidden="true"></i> Admission</Link></li>
                                        <li className='zoom marginFooter' style={{ marginTop: "0.7rem" }}>  <Link to="/facillities" className="text-white color  "> <i className="fa fa-angle-right" aria-hidden="true"></i> Facillities</Link></li>
                                        <li className='zoom marginFooter' style={{ marginTop: "0.7rem" }}>  <Link to="/gallery" className="text-white color  "> <i className="fa fa-angle-right" aria-hidden="true"></i> Gallery</Link></li>
                                    </ul>
                                </div>
                                <div className="col-sm-6 col-md-2 mt-5 mb-5" >

                                    <ul>
                                        <br />
                                        <h3 className="text-white mb-4" >Blog</h3>
                                        <li className='zoom marginFooter' style={{ marginTop: "0.7rem" }}><Link to="/housemaid" className="text-white color mt-1"> <i className="fa fa-angle-right" aria-hidden="true"></i> Contact Us</Link></li>
                                        <li className='zoom marginFooter' style={{ marginTop: "0.7rem" }}>  <Link to="/cook" className="text-white  color "> <i className="fa fa-angle-right" aria-hidden="true"></i> About Us</Link></li>
                                        <li className='zoom marginFooter' style={{ marginTop: "0.7rem" }}><Link to="/babysitter" className="text-white  color "><i className="fa fa-angle-right" aria-hidden="true"></i> Admission</Link></li>
                                        <li className='zoom marginFooter' style={{ marginTop: "0.7rem" }}>  <Link to="/cook" className="text-white color  "> <i className="fa fa-angle-right" aria-hidden="true"></i> Facillities</Link></li>
                                        <li className='zoom marginFooter' style={{ marginTop: "0.7rem" }}>  <Link to="/cook" className="text-white color  "> <i className="fa fa-angle-right" aria-hidden="true"></i> Gallery</Link></li>
                                    </ul>
                                </div>




                                <div className="col-sm-6 col-md-4 mt-5 mb-5" style={{ fontFamily: "Poppins" }}>
                                    <ul>
                                        <br />
                                        <h3 className='text-white mb-4' >Contact</h3>
                                        <li className='text-white d-flex'> <i className="fa fa-phone-square" ></i><span className="mx-1">Manoj Patil:+9183800 48830</span> </li><br />
                                        
                                        <li className='text-white'   > <i className="fa fa-envelope"></i> Shindeinstitute@gmail.com</li><br />
                                        <li className='text-white' ><i className="fa fa-map-marker"></i> Shinde international school in opposite<br /> of Vijaya bank Bhadgaon Road Pachora,<br /> Pachora,Maharashtra</li><br />
                                    </ul>



                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </footer>
            {/* <div className='col-md-12 mt-4' style={{ height: "5rem", background: "rgb(169 128 14)", color: "white", marginBottom: "-4rem" }}>
               
                

            </div> */}

        </>

    );
};

export default Footer;